import PropTypes from "prop-types";
import { connect } from "react-redux";

import permissionsMatch from "utils/permissionsMatch";

/**
 * Provides a wrapper component that only renders its children if the current user has
 * permissions scopes matching the expresssed ones.
 * All required scopes must pass AND at least one of oneOf scopes must pass
 * E.g.:
 *
 * <WithPermissions required={["tag.create"]}>
 *   <button>Create Tag</button>
 * </WithPermissions>
 */
function WithPermissions(props) {
  if (permissionsMatch(props)) {
    return props.children;
  } else {
    return null;
  }
}

WithPermissions.defaultProps = {
  required: [],
  oneOf: [],
  permissions: [],
};

WithPermissions.propTypes = {
  required: PropTypes.arrayOf(PropTypes.string),
  oneOf: PropTypes.arrayOf(PropTypes.string),
  permissions: PropTypes.array,
};

WithPermissions.displayName = "WithPermissions";

const mapStateToProps = state => ({
  permissions: state.user.permissions,
});

export default connect(mapStateToProps)(WithPermissions);
